import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TwinRulesKeyType {
  plural: LocalesKey;
  materialRules: LocalesKey;
  attachmentRules: LocalesKey;
  socketAcceptances: LocalesKey;
  fields: {
    code: LocalesKey;
    meshPattern: LocalesKey;
    materialPattern: LocalesKey;
    hostPattern: LocalesKey;
    partPattern: LocalesKey;
    matchType: LocalesKey;
    mateRotationDeg: LocalesKey;
    mirrorOnMate: LocalesKey;
    nodeId: LocalesKey;
    socketPattern: LocalesKey;
    mode: LocalesKey;
  };
  matchType: {
    prefix: LocalesKey;
    exact: LocalesKey;
  };
  acceptanceMode: {
    acceptByRule: LocalesKey;
    curatedOnly: LocalesKey;
  };
  scope: {
    label: LocalesKey;
    global: LocalesKey;
    company: LocalesKey;
    configurator: LocalesKey;
  };
  addRow: LocalesKey;
  save: LocalesKey;
  unsavedChanges: LocalesKey;
  override: LocalesKey;
  inheritedFrom: LocalesKey;
  noRules: LocalesKey;
  selectCompany: LocalesKey;
  materialRulesInactiveBanner: LocalesKey;
  contextual: {
    inheritedTitle: LocalesKey;
    localTitle: LocalesKey;
    levelGlobal: LocalesKey;
    levelCompany: LocalesKey;
    editOnRulesPage: LocalesKey;
    noInherited: LocalesKey;
    noLocal: LocalesKey;
    addAttachmentRule: LocalesKey;
    materialsPointer: LocalesKey;
    materialRuleInactive: LocalesKey;
    hostSocket: LocalesKey;
    connector: LocalesKey;
    connectorSelectsParts: LocalesKey;
    socketRulesTitle: LocalesKey;
    socketRulesHint: LocalesKey;
    zoneRulesTitle: LocalesKey;
    zoneRulesHint: LocalesKey;
    allowConnector: LocalesKey;
    levelLocal: LocalesKey;
    alreadyAllowed: LocalesKey;
    noSocketRules: LocalesKey;
    advanced: LocalesKey;
    save: LocalesKey;
    cancel: LocalesKey;
    close: LocalesKey;
    remove: LocalesKey;
    preview: {
      title: LocalesKey;
      noViewer: LocalesKey;
      noTargets: LocalesKey;
      noPartsYet: LocalesKey;
      nested: LocalesKey;
      curatedOnlyHint: LocalesKey;
      savedRefreshed: LocalesKey;
    };
  };
}

export const twinRulesKeys = keyPathMirror<TwinRulesKeyType, string>(
  {
    plural: null,
    materialRules: null,
    attachmentRules: null,
    socketAcceptances: null,
    fields: {
      code: null,
      meshPattern: null,
      materialPattern: null,
      hostPattern: null,
      partPattern: null,
      matchType: null,
      mateRotationDeg: null,
      mirrorOnMate: null,
      nodeId: null,
      socketPattern: null,
      mode: null
    },
    matchType: {
      prefix: null,
      exact: null
    },
    acceptanceMode: {
      acceptByRule: null,
      curatedOnly: null
    },
    scope: {
      label: null,
      global: null,
      company: null,
      configurator: null
    },
    addRow: null,
    save: null,
    unsavedChanges: null,
    override: null,
    inheritedFrom: null,
    noRules: null,
    selectCompany: null,
    materialRulesInactiveBanner: null,
    contextual: {
      inheritedTitle: null,
      localTitle: null,
      levelGlobal: null,
      levelCompany: null,
      editOnRulesPage: null,
      noInherited: null,
      noLocal: null,
      addAttachmentRule: null,
      materialsPointer: null,
      materialRuleInactive: null,
      hostSocket: null,
      connector: null,
      connectorSelectsParts: null,
      socketRulesTitle: null,
      socketRulesHint: null,
      zoneRulesTitle: null,
      zoneRulesHint: null,
      allowConnector: null,
      levelLocal: null,
      alreadyAllowed: null,
      noSocketRules: null,
      advanced: null,
      save: null,
      cancel: null,
      close: null,
      remove: null,
      preview: {
        title: null,
        noViewer: null,
        noTargets: null,
        noPartsYet: null,
        nested: null,
        curatedOnlyHint: null,
        savedRefreshed: null
      }
    }
  },
  'models.twinRules.'
);
